import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { CommonCommunicationService } from '../services/commonCommunication.service';
import { StorageService } from '../services/storage.service';
import { Router } from '@angular/router';

interface TokenRefreshResult {
  token: string;
  tokenExpiresAt: string;
  userId: string;
}

@Injectable()
export class ExpiryInterceptor implements HttpInterceptor {
    private readonly REFRESH_TOKEN_URL = 'user/get-access-token';
  constructor(
    private authService: AuthService,
    private ccs: CommonCommunicationService,
    private storageService: StorageService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes(this.REFRESH_TOKEN_URL)) {
        return next.handle(req);
      }
    return from(this.refreshTokenIfNeeded()).pipe(
      switchMap(() => {
        return next.handle(req);
      })
    );
  }

  private logout() {
    this.storageService.clear();
    this.router.navigate(['/auth/login']);
  }

  private async refreshTokenIfNeeded(): Promise<void> {
    const tokenExpiresAt = localStorage.getItem('tokenExpiresAt');
    if (!tokenExpiresAt) {
      return;
    }

    const cleanTokenExpiresAt = tokenExpiresAt.replace(/['"]+/g, '').trim();
    
    // Use Date.parse instead of new Date().getTime()
    const expiresAt = Date.parse(cleanTokenExpiresAt);
    const now = Date.now();
    const oneMinutesInMs = 5 * 60 * 1000;
    const timeUntilExpiry = expiresAt - now;

    if (timeUntilExpiry < oneMinutesInMs) {
      try {
        const result = await this.authService.refreshToken().toPromise() as TokenRefreshResult | undefined;
        if (result?.token && result?.tokenExpiresAt) {
          this.ccs.setJwtToken(result.token);
          let accessTokenString = JSON.stringify(result.token);
          localStorage.setItem('token', accessTokenString);          
          localStorage.setItem('tokenExpiresAt', result.tokenExpiresAt);
        } else {
          throw new Error('Invalid refresh token response');
        }
      } catch (error) {
        console.error('ExpiryInterceptor: Failed to refresh token:', error);
        this.logout()
        throw error;
      }
    } else {
    }
  }
}